import http from "./http";
import type { LibroDeCurso } from '../models/libro_de_curso_model';
import type { ActivitiesData } from '../models/libro_de_curso_grid_activities_model';

export const getCourseBookByDate = async (week?: number, year?: number) => {
  try {
    const filters = [];

    if (week) {
      filters.push(`semana=${week}`)
    }

    if (year) {
      filters.push(`anio=${year}`)
    }

    return await http.get<LibroDeCurso | null>(`/kinder/libro-curso/${filters.length ? ('?' + filters.join('&')) : ''}`);
  } catch (error) {
    console.error("[get_libro_de_curso]  Error -> ", error);
    return null;
  }
};

export const saveActivities = async (data: ActivitiesData, fecha: string) => {
  try {
    return await http.post<unknown, ActivitiesData>(`/kinder/actividades/${fecha ? fecha : ''}`, data);
  } catch (error) {
    console.error("[save_activities_libro_de_curso]  Error -> ", error);
    return null;
  }
};